import axios, { AxiosError } from 'axios';
import { getLogger } from '../diagnostics/logger';
import { MvnoBundle } from 'src/models/state/mvnoBundle';
import { getSimManagementErrorFromAxiosError } from '.';

import config from '../config';
const log = getLogger('simManagement.api.orangeProvisioningOrderApi');

export function getBundle(serialNo: string): Promise<any> {
  const url = config.API_BASE_URL + `api/sim/${serialNo}/mvnoBundles`;
  return new Promise<MvnoBundle>((resolve, reject) => {
    axios
      .get(url)
      .then((response: any) => {
        const result = response.data;
        resolve(result);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error(`Failed to load mvno bundle by tel ${serialNo}.`, simManagementError);
        reject(simManagementError);
      });
  });
}
